import { useNavigate } from "react-router";

const SponsorRegistrationP3 = () => {

    const navigate = useNavigate();

      const handleRedirect = () => {
        navigate("/registration-status");
    };


  return (
    <div className="page-wrapper">
      <div className="d-flex gap-5 m-5 pt-4 text-nightblue justify-content-center">
       <div className="bg-white p-4 rounded shadow-sm w-100">
        <h3 className=" d-flex align-items-center"><i className="feather feather-check-circle text-success p-1 me-2 fs-3"></i>Payment Successful!</h3>
         <div className="border my-3" style={{ height: "1px" }}></div>
        <p className="my-3">
            You have successfully made the payment for your registration application. You can now go to your Dashboard to check the status of your registration.
        </p>
      <div className="d-flex justify-content-end mt-5 gap-2 ">
        <div className="d-flex gap-2">
        <button className="btn btn-info px-3"onClick={handleRedirect}>View Application Status</button>
        <button className="px-3 text-info rounded" style={{border:"none", backgroundColor:"white",}}>Download Receipt</button>
      </div>
      </div>
      </div>
      </div>
    </div>
  );
};

export default SponsorRegistrationP3;
